var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { style: "margin-left:" + _vm.level * 35 + "px;" },
      [
        _c(
          "v-row",
          [
            _c(
              "v-col",
              [
                _c("workflow-item-type-and-params", {
                  style: {
                    "margin-bottom": _vm.item.type === "start" ? "30px" : 0
                  },
                  attrs: { params: _vm.item.params, type: _vm.item.type },
                  on: {
                    "update:params": function($event) {
                      return _vm.$set(_vm.item, "params", $event)
                    },
                    "update:type": function($event) {
                      return _vm.$set(_vm.item, "type", $event)
                    }
                  }
                }),
                _c("v-select", {
                  staticStyle: {
                    "max-width": "300px",
                    display: "inline-block",
                    "max-height": "65px"
                  },
                  attrs: {
                    items: _vm.workflowOptions,
                    "item-text": "text",
                    "item-value": "value",
                    label:
                      _vm.item.type !== "start"
                        ? _vm.$t("settings.workflow.conditionTrue")
                        : _vm.$t("settings.workflow.startAction"),
                    outlined: ""
                  },
                  model: {
                    value: _vm.contextTrueResult,
                    callback: function($$v) {
                      _vm.contextTrueResult = $$v
                    },
                    expression: "contextTrueResult"
                  }
                }),
                typeof _vm.contextTrueResult === "string"
                  ? _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("fa-level-down-alt")
                    ])
                  : _vm._e(),
                _vm.contextTrueResult === "acceptationBySpecifiedUsers"
                  ? _c("workflow-item-acceptation-by", {
                      attrs: {
                        level: _vm.level + 1,
                        "user-ids": _vm.item.conditionalTrueResult
                      }
                    })
                  : _vm._e(),
                typeof _vm.contextTrueResult === "string" &&
                _vm.contextTrueResult !== "acceptationBySpecifiedUsers"
                  ? _c("workflow-item", {
                      attrs: {
                        item: _vm.item.conditionalTrueResult,
                        level: _vm.level + 1
                      },
                      on: {
                        "update:item": function($event) {
                          return _vm.$set(
                            _vm.item,
                            "conditionalTrueResult",
                            $event
                          )
                        }
                      }
                    })
                  : _vm._e(),
                typeof _vm.item.conditionalFalseResult !== "undefined" &&
                _vm.item.type !== "start"
                  ? _c(
                      "span",
                      [
                        _c("br"),
                        _c("v-select", {
                          staticStyle: {
                            "max-width": "300px",
                            display: "inline-block",
                            "max-height": "55px"
                          },
                          attrs: {
                            items: _vm.workflowOptions,
                            "item-text": "text",
                            "item-value": "value",
                            label: _vm.$t("settings.workflow.conditionFalse"),
                            outlined: ""
                          },
                          model: {
                            value: _vm.contextFalseResult,
                            callback: function($$v) {
                              _vm.contextFalseResult = $$v
                            },
                            expression: "contextFalseResult"
                          }
                        }),
                        typeof _vm.contextFalseResult === "string"
                          ? _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("fa-level-down-alt")
                            ])
                          : _vm._e(),
                        _vm.contextFalseResult === "acceptationBySpecifiedUsers"
                          ? _c("workflow-item-acceptation-by", {
                              attrs: {
                                level: _vm.level + 1,
                                "user-ids": _vm.item.conditionalFalseResult
                              }
                            })
                          : _vm._e(),
                        typeof _vm.contextFalseResult === "string" &&
                        _vm.contextFalseResult !== "acceptationBySpecifiedUsers"
                          ? _c("workflow-item", {
                              attrs: {
                                item: _vm.item.conditionalFalseResult,
                                level: _vm.level + 1
                              },
                              on: {
                                "update:item": function($event) {
                                  return _vm.$set(
                                    _vm.item,
                                    "conditionalFalseResult",
                                    $event
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }